export function handleEncryptionAccessDisabled(response: Response | null | undefined): void {
    if (response?.headers?.get("X-Encryption-Access-Disabled") === "1") {
        // The next navigation renders the generic blocked page using the same org cache.
        globalThis.location.reload();
    }
}
